import Services from '../../services'

const state = {
  rates: []
};

// getters
const getters = {
  rates: (state, getters, root) => {
    return state.rates;
  },
};

// actions
const actions = {
  async fetchRates({ commit, state, dispatch }) {
    const data = await Services.Rates.fetchRates();
    let rates = data.default.map(e => { e.small = true; return e; })
    commit('updateRates', rates);
  },
};

// mutations
const mutations = {
  updateRates(state, data) {
    state.rates = [].concat(data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/rates.js